import React from 'react'

const MatchSearchHeader = () => (
    <>
        <p>
            The Matching Tool enables you to suggest matches between
            <a target="_blank" rel="noreferrer" href="https://help.themlc.com/en/support/what-is-a-sound-recording">
                &nbsp;sound recordings&nbsp;
            </a>
            and works in your catalog. This helps ensure that you&apos;ll collect the royalties you&apos;re owed for
            your works.
        </p>
        <p>
            To begin, use the search fields below to find recordings that haven't yet been matched to your works. Search
            results will be grouped together based on similar data and will be sorted by relevance.
        </p>
        <p>
            In the next step, you will locate the specific work in your catalog that you want to match to the selected
            recording.
        </p>
    </>
)

export default MatchSearchHeader
